import coreAnalytics from '@nrk/core-analytics'
import { PartialCoreAnalyticsGAData } from '../types'
import { Locale } from '../v1/domain'

export type SendGaEvent = (event: PartialCoreAnalyticsGAData) => void
export type SendPageView = (page: string) => void
export type LinkClickType =
  | 'SEARCH'
  | 'NAV'
  | 'TABLE'
  | 'PRIMAR-HEADING'
  | 'HEADER'
  | 'LANG'
  | 'DEFAULT'
  | 'NOT-FOUND-BACK'
  | 'FYLKESVALG-I-KOMMUNE'

export const GA_EVENTS = {
  LOAD_SEKUNDAR: (type: 'kommune' | 'fylke') => ({ eventAction: `LOAD_SEKUNDAR/${type}` }),
  EXPAND_OPEN: (modulnavn: string, valgtype: 'kommune' | 'fylke', grunndata: string) => ({
    eventAction: `EXPAND_OPEN/${valgtype}/${grunndata}/${modulnavn}/`
  }),
  EXPAND_CLOSE: (modulnavn: string, valgtype: 'kommune' | 'fylke', grunndata: string) => ({
    eventAction: `EXPAND_CLOSE/${valgtype}/${grunndata}/${modulnavn}/`
  }),
  TAB_CHANGE: (
    modulnavn: string,
    valgtype: 'kommune' | 'fylke',
    grunndata: string,
    activeTab: string
  ) => ({ eventAction: `TAB_CHANGE/${valgtype}/${grunndata}/${modulnavn}/${activeTab}` }),
  SCROLL_BUTTON_CLICKED: (
    modulnavn: string,
    valgtype: 'kommune' | 'fylke',
    grunndata: string,
    direction: 'left' | 'right'
  ) => ({
    eventAction: `SCROLL_BUTTON_CLICKED/${valgtype}/${grunndata}/${modulnavn}/${direction}`
  }),
  SCROLL_ACTIVE_CHANGED: (
    modulnavn: string,
    valgtype: 'kommune' | 'fylke',
    grunndata: string,
    nextIndex: 'left' | 'right'
  ) => ({ eventAction: `SCROLL_NEXT_INDEX/${valgtype}/${grunndata}/${modulnavn}/${nextIndex}` }),
  MOUNT: () => ({ eventAction: 'MOUNT' }),
  MOUNT_WIDGET: widgetPath => ({ eventAction: `MOUNT_WIDGET${widgetPath}` }),
  PAGE_CHANGE: () => ({ eventAction: 'PAGE_CHANGE' }),
  LOCALE_CHANGE: (locale: Locale) => ({ eventAction: `LOCALE_CHANGE/${locale}` }),
  LINK_CLICK: (type: LinkClickType, pathname) => {
    // Remove the starting slash if the pathname starts with a slash
    return { eventAction: `LICK_CLICK/${type}/${pathname.replace(/^\//, '')}` }
  }
}

export function getContextId(url: string) {
  const POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g
  const matches = url.match(POLOPOLY_ID_REGEX)
  if (matches && matches.length) {
    return matches[0]
  }
  return null
}

interface Metadata {
  title?: string
  selfId?: string
  published?: string
}

export function initializeAnalytics(el): { sendGaEvent: SendGaEvent; sendPageview: SendPageView } {
  const name = el.getAttribute('data-name')
  const metadata: Metadata = JSON.parse(el.getAttribute('data-metadata') || '{}')

  const coreAnalyticsTracker = coreAnalytics.create()
  coreAnalyticsTracker('initialize', {
    trackerName: 'dh',
    container: el,
    parentId: getContextId(window.location.href),
    ga: el.getAttribute('data-ga-property-id') || undefined
  })

  coreAnalyticsTracker('context', {
    title: metadata.title,
    contentId: metadata.selfId,
    publishDate: metadata.published
  })

  const sendGaEvent = (event: PartialCoreAnalyticsGAData) => {
    coreAnalyticsTracker('event', {
      ga: {
        eventCategory: `dh-modul-${name}`,
        ...event
      }
    })
  }

  const sendPageview = (page: string) => {
    coreAnalyticsTracker('pageview', {
      page,
      tnsSection: 'nrk/valgresultat',
      ga: {
        eventCategory: `dh-modul-${name}`
      }
    })
  }

  return { sendGaEvent, sendPageview }
}
